import React from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import {
  ResizeHandlePosition,
  ResizeHandleProps,
} from "./resizableImage.types";

const getHandleStyles = (position: ResizeHandlePosition) => {
  const basePosition = {
    "top-left": { top: -6, left: -6, cursor: "nwse-resize" },
    "top-right": { top: -6, right: -6, cursor: "nesw-resize" },
    "bottom-left": { bottom: -6, left: -6, cursor: "nesw-resize" },
    "bottom-right": { bottom: -6, right: -6, cursor: "nwse-resize" },
  };
  return basePosition[position];
};

export const ResizeHandle: React.FC<ResizeHandleProps> = ({
  position,
  onResizeStart,
  onTouchStart,
}) => {
  const theme = useTheme();
  const positionStyles = getHandleStyles(position);

  return (
    <Box
      className={`resize-handle resize-handle-${position}`}
      onMouseDown={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onResizeStart(position, e);
      }}
      onTouchStart={(e) => {
        e.stopPropagation();
        onTouchStart(position, e);
      }}
      sx={{
        position: "absolute",
        width: "12px",
        height: "12px",
        backgroundColor: theme.palette.common.white,
        border: `2px solid ${theme.palette.primary.main}`,
        borderRadius: "2px",
        zIndex: 10,
        transition: "transform 0.15s ease, background-color 0.15s ease",
        "&:hover": {
          backgroundColor: theme.palette.primary.light,
          transform: "scale(1.2)",
        },
        ...positionStyles,
      }}
    />
  );
};
